//  Time-stamp: "2016-07-25 06:57:55 MDT"
module.exports = [
' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', "", "", "", "",
"-", "-", "-", "-", "--", "--", "||", "_", "'", "'", ",", "'", "\"", "\"", ",,", "\"",
"+", "++", "*", "*>", ".", "..", "...", ".", "\\n", "\\n\\n", "", "", "", "", "", ' ',
"%0", "%00", "'", "''", "'''", "`", "``", "```", "^", "<", ">", "*", "!!", "!?", "-", "_",
"-", "^", "***", "--", "/", "-[", "]-", '[?]', "?!", "!?", '7', 'PP', "(]", "[)", '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', "", "", "", "", "", "",
'0', "", "", "", '4', '5', '6', '7', '8', '9', "+", "-", "=", "(", ")", 'n',
'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', "+", "-", "=", "(", ")", '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'ECU', 'CL', 'Cr', 'FF', 'L', 'mil', 'N', 'Pts', 'Rs', 'W', 'NS', 'D', 'EUR', 'K', 'T', 'Dr',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
];
